export const featureContainerSx = (theme) => ({
  display: 'block',
  margin: '48px 48px 0px 0px',
  flex: 1,
  [theme.breakpoints.between('xs', 'sm')]: {
    flexBasis: '100%',
  },
  [theme.breakpoints.between('sm', 'md')]: {
    flexBasis: '40%',
  },
  [theme.breakpoints.up('md')]: {
    flexBasis: '25%',
  },
});

export const headingSx = {
  fontWeight: 900,
  fontSize: '20px !important',
  margin: '8px 0 16px',
};

export const contentSx = {};
